import { TrackEventBody } from '@/types/track-events'
import { requests } from '.'
import config from '../config'

export const OnboardingService = {
  verifyEmail: (body: any) =>
    requests(config.onboardingUrl).post(`/verify/email`, body),
  verifyPhone: (body: any) =>
    requests(config.onboardingUrl).post(`/verify/phone`, body),
  trackEvents: (body: TrackEventBody) =>
    requests(config.onboardingUrl).post(`/track/events`, body)
}
